module.exports = __webpack_public_path__ + "img/map-01.9eb4fdce.svg";